import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const ToastManager = () => {
  const location = useLocation();

  const isSearchPage =
    location.pathname.includes("search") ||
    location.pathname.includes("search-result");

  if (isSearchPage) {
    return (
      <ToastContainer
        containerId="search-toast"
        position="bottom-left"
        autoClose={6000}
        theme="light"
        toastStyle={{
          background: "#fff",
          color: "#111",
          borderRadius: "10px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)"
        }}
      />
    );
  }

  return (
    <ToastContainer
      containerId="global-toast"
      position="top-right"
      autoClose={4000}
      hideProgressBar={false}
      closeOnClick
      pauseOnHover
      draggable
      limit={3}
    />
  );
};

export default ToastManager;